import styled from 'styled-components';

export const GalleryWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  border: 1px solid #ebeaea;
  border-radius: 10px;
  background-color: white;
`;

export const GalleryGrid = styled.div<{ itemsize: number }>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${({ itemsize }) => itemsize}px, 1fr));
  gap: 10px;
  padding: 10px;
`;

export const GalleryItemWrapper = styled.div<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  transition: all 0.2s ease;
`;

export const GalleryCounter = styled.div`
  margin-top: 10px;
  margin-left: 10px;
`;


export const ToolbarWrapper = styled.div<{ mode?: string }>`
  .e-toolbar,
  .e-toolbar .e-toolbar-item,
  .e-toolbar-items {
    background-color: ${({ mode }) => (mode === 'edit' ? 'rgba(167, 211, 255, 0.03)' : 'white')} !important;
  }

  .e-scroll-nav,
  .e-scroll-nav:hover {
    background-color: ${({ mode }) => (mode === 'edit' ? 'rgba(167, 211, 255, 0.03)' : 'white')} !important;
    border: none !important;
  }
`;
